import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';

import ResourceCategoriesAccordion from 'containers/ResourceCategoriesAccordion';
import InterestsTopicCheckbox from './InterestsTopicCheckbox';
import * as actions from 'actions';
import './style.scss';

class Interests extends Component {

  constructor() {
    super();

    this.renderTopic = this.renderTopic.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
  }

  handleCheckboxClick(checkboxData) {
    if(this.props.onTopicClick) {
      this.props.onTopicClick(checkboxData);
    }
  }

  renderTopic(topic) {
    return (
      <InterestsTopicCheckbox
        key={topic.id}
        topic={topic}
        onClick={this.handleCheckboxClick}
      />
    );
  }

  render() {
    return (
      <section className="Interests content-wrapper has-background" ref="wrapper">
        <div className="wrapper-small is-padded-vertical">
          <h1>{__('members.interests.title')}</h1>

          <ResourceCategoriesAccordion
            isForMagazine
            resourceType="articles"
            resourceNameSingular={__('entities.articles.singular')}
            resourceNamePlural={__('entities.articles.plural')}
            renderTopic={this.renderTopic}
            scrollElementGetter={() => this.refs.wrapper}
            />
        </div>
      </section>
    );
  }
}

Interests.propTypes = {
  onTopicClick: PropTypes.func
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    onTopicClick: data => {
      const { id, isChecked } = data;
      const interestedIn = !isChecked;
      dispatch(actions.topicUpdate(id, { interestedIn }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Interests);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Interests/index.js
 **/